import LegalityCheck from './LegalityCheck';

export default LegalityCheck;
